import React, { useState } from "react";
import "./Sidebar.css";

const ChatPagemapSidebar = ({ story, className }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleDoubleClick = () => {
    setIsModalOpen(true);
  };

  const handleClose = () => {
    setIsModalOpen(false);
  };

  return (
    <div className={`chat-sidebar ${className || ""}`}>
      <div className="sidebar-section">
        <h3>クリックした場所までの本文</h3>
        <p>※＋アイコンから</p>
        <p>選択肢を追加してください</p>
        <p onDoubleClick={handleDoubleClick} style={{ cursor: "pointer" }}>
          {story?.currentNodeContent
            ? story.currentNodeContent.split(" ").map((text, index) => (
                <React.Fragment key={index}>
                  {text}
                  <br />
                </React.Fragment>
              ))
            : "本文がありません"}
        </p>
      </div>

      {isModalOpen && (
        <div className="modal-overlay">
          <div className="modal-content">
            <button className="modal-close-btn" onClick={handleClose}>
              ×
            </button>
            <div>
              {story?.currentNodeContent
                ? story.currentNodeContent
                : "本文がありません"}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};


export default ChatPagemapSidebar;
